import script from "./NumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInput.vue?vue&type=script&setup=true&lang=js"

import "./NumberInput.vue?vue&type=style&index=0&id=77efed88&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77efed88"]])

export default __exports__